import Text from '@shared/components/Text/Text'
import { root } from './InputRow.css'

type InputRowProps = {
  label: string
  type?: string
  name?: string
  required?: boolean
  placeholder?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  value?: string
} & React.InputHTMLAttributes<HTMLInputElement>

export default function InputRow({
  label,
  /** The input's value is available in server actions on the form submittion via this name */
  name = label,
  required,
  type = 'text',
  placeholder = ' ', // Use space so that the CSS :placeholder-shown selector works
  value,
  onChange,
  ...restProps
}: InputRowProps) {
  return (
    <label className={root}>
      <Text size='small' as='span'>
        {label}
      </Text>
      <input
        type={type}
        name={name}
        required={required}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        {...restProps}
      />
    </label>
  )
}
